module.exports = __webpack_public_path__ + "media/images/athletes/1081-be535d994026f1ba180de3c03221a8d7.png";